/**
 * Soldier — one body in a melee squad. A melee Unit fields `squadSize` of these
 * on the line; each holds its own enemies, has its own HP bar, fights, falls,
 * and respawns INDIVIDUALLY (engine-agnostic, no Phaser). The squad's collective
 * HP / block capacity / DPS is the sum across its living soldiers, so killing
 * one soldier opens a gap without taking the whole unit off the line.
 */
export class Soldier {
  hp = 0;
  maxHp = 0;
  /** True while this body has fallen and waits to respawn (doesn't block/fight). */
  dead = false;
  /** Seconds until a fallen soldier respawns at full HP. */
  respawnRemaining = 0;
  attackCooldown = 0;
  /** Path distance of the enemy this soldier is currently engaging, or null when
   *  idle (it then waits at the squad's hold line). Drives where the renderer
   *  walks the soldier body to — out from the building to meet its foe. */
  engagedDistance: number | null = null;
}
